// extracted by mini-css-extract-plugin
export default {"affair":"Affair_affair__h9Sbh","name":"Affair_name__3W7C7","closeButton":"Affair_closeButton__WtPsO"};